// extracted by mini-css-extract-plugin
module.exports = {"pagination":"Paginator_pagination__3y8s7"};